import { LazyFallback } from 'components/shared/LazyFallback';
import { FC, Suspense } from 'react';
import { lazyWithRetry } from 'shared/lazy';

const SecondaryTradesBlotterRouteLazy = lazyWithRetry(() => import('./SecondaryTradesBlotter'));
export const SecondaryTradesBlotterRoute: FC = () => (
  <Suspense fallback={<LazyFallback />}>
    <SecondaryTradesBlotterRouteLazy />
  </Suspense>
);
